module.exports = __webpack_public_path__ + "static/media/submit.e135491c.PNG";